module.exports = __webpack_public_path__ + "static/media/chat.67499349.svg";